<template>
  <div>
    <div :id="id" :style="basicLayout"></div>
    <!-- <img src="../assets/map icons/portIcon.png" style="width:24px;height:24px"  id="image" alt=""> -->
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
// import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import axios from "axios";
import moment from "moment";

export default {
  name: "SMap",

  data() {
    return {
      accessToken:
        "pk.eyJ1IjoibXVoYW1tYWQtc2FhZCIsImEiOiJjazVjNXk0eDMxaWdoM25wc3hwd2tjNnJ0In0.kv0JZTEZh-hgD6jMnV1zwg",
      map: null,
      id: "container_" + this._uid,
      // zoom: 5.5,
      minZoom: 2.5,
      showMarkers: false,
      geoJsonSource: null,
      geoJsonLayer: null,
      geoJsonSourceCluster: null,
      geoJsonLayerCluster: null,
      geoJsonLayerClusterCount: null,
      targetZoom: null,
      searchMarker: null,
      searchOpts: [],
      posLat: 0,
      posLng: 0,
      cargoPickedUpDate: "",
      originCustomRelasedDate: "",
      departedDate: "",
      destinationCustomRealasedDate: "",
      arrivedDate: "",
      availableForDropOffDate: "",
      DropOffDate: "",
      showTypeOfTransport: "",
    };
  },

  props: {
    shipment: {
      type: Object,
    },
    mapShipmentPage: {
      type: Boolean,
      default: false,
    },
    shipPosition: {
      type: Array,
    },
    height: {
      type: Number,
      required: true,
    },
    markers: {
      type: Array,
    },
    animation: {
      type: Boolean,
      default: false,
    },
    clusters: {
      type: Boolean,
      default: false,
    },
    route: {
      type: Boolean,
      default: false,
    },
    zoom: {
      default: 6,
    },
    searchFlag: {
      type: Boolean,
      default: false,
    },
    searchtText: {
      type: String,
      default: "",
    },
    searchCoors: {
      type: Object,
      default: () => {
        return {
          latitude: null,
          longitude: null,
        };
      },
    },
    source: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    basicLayout: function() {
      return {
        width: "100%",
        height: this.height + "px",
      };
    },
  },

  mounted() {
    if (this.shipPosition == null || this.shipPosition == undefined) {
      this.posLat = 0;
      this.posLng = 0;
    } else {
      this.posLat = this.shipPosition[0];
      this.posLng = this.shipPosition[1];
    }
    mapboxgl.accessToken = this.accessToken;
    let coors;
    if (this.markers) {
      coors = [this.markers[0].lng, this.markers[0].lat];
    } else {
      coors = [53.8784, 23.2421];
    }
    this.map = new mapboxgl.Map({
      container: this.id,
      style: "mapbox://styles/mapbox/light-v10",
      // center:[this.markers[0].lng, this.markers[0].lat],
      // center: [53.8784, 23.2421],
      // zoom: 15,
      zoom: this.zoom,
      center: coors,
      // projection: 'globe'
      // projection: 'equalEarth'
      // projection: 'naturalEarth'
    });
    // console.log(this.map.center)
    // markers (if any)
    if ((!this.clusters && !this.route && this.searchFlag) || this.markers) {
      if (this.markers) {
        this.drawMarker();
        this.dynamicallyFitMapBounds();
      }
      // search
      if (this.searchFlag) {
        this.addSourceToMap();
      }
    }

    if (this.clusters) {
      //   this.drawClusters();
      this.customClusters();
      this.dynamicallyFitMapBounds();
    }

    if (this.route && !this.clusters) {
      this.drawLine();
      this.drawMarker();
    }
    if (this.shipPosition) {
      this.drawLine();
    }
  },
  created() {
    this.getEventsData();
    this.getTransportType();
  },
  methods: {
    getTransportType() {
      if (this.shipment != undefined && this.shipment.transportTypes == "Door To Port") {
        this.showTypeOfTransport = "Door To Port";
      } else if (this.shipment != undefined && this.shipment.transportTypes == "Port To Door") {
        this.showTypeOfTransport = "Port To Door";
      } else if (this.shipment != undefined && this.shipment.transportTypes == "Door to Door") {
        this.showTypeOfTransport = "Door To Door";
      } else if (this.shipment != undefined && this.shipment.transportTypes == "Port to Port") {
        this.showTypeOfTransport = "Port To Port";
      }
    },
    dateFormated(dt) {
      return dt ? moment(dt).format("DD MMM YYYY") : "--";
    },
    getEventsData() {
      if(this.shipPosition != undefined){
        this.shipPosition.filter((evt) => {
          if (evt.eventName == "Pick-up") {
            this.cargoPickedUpDate = evt.eventDateTime;
          }
          if (evt.eventName == "Origin Customs Released") {
            this.originCustomRelasedDate = evt.eventDateTime;
          }
          if (evt.eventName == "Departed") {
            this.departedDate = evt.eventDateTime;
          }
          if (evt.eventName == "Destination Customs Released") {
            this.destinationCustomRealasedDate = evt.eventDateTime;
          }
          if (evt.eventName == "Arrived") {
            this.arrivedDate = evt.eventDateTime;
          }
          if (evt.eventName == "Available for Drop-off") {
            this.availableForDropOffDate = evt.eventDateTime;
          }
          if (evt.eventName == "Drop-off") {
            this.DropOffDate = evt.eventDateTime;
          }
        });
      }      
    },
    drawMarker() {
      // const popup = new mapboxgl.Popup({ offset: 25 }).setText('POL');
      if (this.mapShipmentPage) {
        if (this.markers.length > 0) {
          for (let i = 0; i < this.markers.length; i++) {
            var img = document.createElement("img");
            img.style = "width:24px; height:24px";
            if (this.markers[i].origin) {
              if (this.markers[i].type === "port") {
                img.src = require("../assets/containers-new.png");
              }
              var markerOrigin;
              markerOrigin = new mapboxgl.Marker({
                color: "#000000",
                scale: 0.75,
                element: img,
              })
                .setLngLat([this.markers[i].lng, this.markers[i].lat])
                .addTo(this.map);

              const title = this.markers[i].title;
              const popupContent = `
              <div class="card" style="padding:5px">
                <div> 
                  <div style="font-size:12px;font-weight:700"> Origin Port </div>
                </div>
                <div style="margin-bottom:10px"> 
                  ${title} 
                </div> 
                <div>
                  <div style="display:flex">
                    <div><img src="${require("../assets/calendar.png")}" alt="Image Description1"/> </div>  
                    <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px"> CARGO READY DATE </div>
                  </div>
                  <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                    ${this.dateFormated(this.shipment.cargoReadyDate)}
                  </div>
                </div>
              </div>`;
              const popup = new mapboxgl.Popup({
                offset: 15,
                closeButton: false,
                closeOnClick: false,
              }).setHTML(popupContent);
              markerOrigin.setPopup(popup);
              const markerDiv = markerOrigin.getElement();

              markerDiv.addEventListener("mouseenter", () => {
                markerOrigin.togglePopup();
                img.src = require("../assets/container-red.png");
              });
              markerDiv.addEventListener("mouseleave", () => {
                markerOrigin.togglePopup();
                img.src = require("../assets/containers-new.png");
              });
            }
            if (this.markers[i].destination) {
              var imgDest = document.createElement("img");
              imgDest.style = "width:24px; height:24px";
              if (this.markers[i].type === "port") {
                imgDest.src = require("../assets/containers-new.png");
              }
              var markerDes;
              markerDes = new mapboxgl.Marker({
                color: "#000000",
                scale: 0.75,
                element: imgDest,
              })
                .setLngLat([this.markers[i].lng, this.markers[i].lat])
                .addTo(this.map);
              const title = this.markers[i].title;
              const popupContent = `
              <div class="card" style="padding:5px">
                <div> 
                  <div style="font-size:12px;font-weight:700"> Destination Port </div>
                </div>
                <div style="margin-bottom:10px"> 
                  ${title} 
                </div> 
                <div>
                  <div style="display:flex">
                    <div><img src="${require("../assets/calendar.png")}" alt="Image Description1"/> </div>  
                    <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px"> CARGO DELIVERED </div>
                  </div>
                  <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                    ${this.dateFormated(this.DropOffDate)}
                  </div>
                </div>
              </div>`;
              const popup = new mapboxgl.Popup({
                offset: 15,
                closeButton: false,
                closeOnClick: false,
              }).setHTML(popupContent);
              markerDes.setPopup(popup);
              const markerDivDest = markerDes.getElement();

              markerDivDest.addEventListener("mouseenter", () => {
                markerDes.togglePopup();
                imgDest.src = require("../assets/container-red.png");
              });
              markerDivDest.addEventListener("mouseleave", () => {
                markerDes.togglePopup();
                imgDest.src = require("../assets/containers-new.png");
              });
            }
          }
        }
      } 
      else {
        if (this.markers.length > 0) {
          let count = 0;
          for (let i = 0; i < this.markers.length; i++) {
            count++;
            var img = document.createElement("img");
            img.style = "width:24px; height:24px";
            var marker;
            if (
              this.markers[i].type === null ||
              this.markers[i].type === undefined
            ) {
              if (this.markers[i].title) {
                this.displayPortName(this.markers[i], count);
              }
              marker = new mapboxgl.Marker({
                color: "#000000",
                scale: 0.75,
              })
                .setLngLat([this.markers[i].lng, this.markers[i].lat])
                .addTo(this.map);
            }
            if (this.markers[i].type) {
              if (this.markers[i].type === "port") {
                img.src = require("../assets/map icons/portIcon.png");
              } else {
                img.src = require("../assets/map icons/location.png");
              }
              if (this.markers[i].title) {
                this.displayPortName(this.markers[i], count);
              }

              marker = new mapboxgl.Marker({
                color: "#000000",
                scale: 0.75,
                element: img,
              })
                .setLngLat([this.markers[i].lng, this.markers[i].lat])
                .addTo(this.map);
            }
          }
        }
      }
      // position Marker events based code start here
      if(this.shipPosition != undefined){
      for (let i = 0; i < this.shipPosition.length; i++) {
        let icon = document.createElement("img");
        // 2- Pickup event
        if (this.shipPosition[i].eventName == "Pick-up") {
          icon.src = require("../assets/truck.png");
          icon.style.width = "20px";
          const positionMarker = new mapboxgl.Marker({
            color: "#000000",
            scale: 0.75,
            element: icon,
          })
            .setLngLat([this.shipPosition[i].lng, this.shipPosition[i].lat])
            .addTo(this.map);
          const transportTypes = this.showTypeOfTransport;
          const popupContent = `
          <div class="card" style="padding:5px">
            <div> 
              <div style="font-size:12px;font-weight:700"> Transport </div>
            </div>
            <div style="margin-bottom:10px"> 
              ${transportTypes} 
            </div>
            <div>
              <div style="display:flex">
                <div><img src="${require("../assets/calendar.png")}" alt="Image Description1"/> </div>  
                <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px"> CARGO PICKED UP  </div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                ${this.dateFormated(this.cargoPickedUpDate)}
              </div>
            </div>
          </div>`;
          const popup = new mapboxgl.Popup({
            offset: 15,
            closeButton: false,
            closeOnClick: false,
          }).setHTML(popupContent);
          positionMarker.setPopup(popup);
          const markerDiv = positionMarker.getElement();
          markerDiv.addEventListener("mouseenter", () =>
            positionMarker.togglePopup()
          );
          markerDiv.addEventListener("mouseleave", () =>
            positionMarker.togglePopup()
          );
        }
        // 3- Origin Customs Released Event
        if (this.shipPosition[i].eventName == "Origin Customs Released") {
          const defaultImageSrc = require("../assets/containers-new.png");
          const hoverImageSrc = require("../assets/container-red.png");
          const icon = document.createElement("img");
          icon.src = defaultImageSrc;
          icon.style.width = "20px";
          const positionMarker = new mapboxgl.Marker({
            color: "#000000",
            scale: 0.75,
            element: icon,
          })
          .setLngLat([this.shipPosition[i].lng, this.shipPosition[i].lat])
          .addTo(this.map);
          const portOfLoadingName = this.shipment.portOfLoadingName;
          const popupContent = `
          <div class="card" style="padding: 5px;">
            <div>
              <div style="font-size:12px;font-weight:700">Port Name</div>
            </div>
            <div style="margin-bottom:10px">
              ${portOfLoadingName}
            </div>
            <div>
              <div style="display:flex">
                <div>
                  <img src="${require("../assets/calendar.png")}" alt="Image Description1"/>
                </div>
                <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">CUSTOMS CLEARANCE</div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                ${this.dateFormated(this.originCustomRelasedDate)}</div>
            </div>
            <div>
              <div style="display:flex">
                <div>
                  <img src="${require("../assets/calendar.png")}" alt="Image Description1"/>
                </div>
                <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">ESTIMATED DEPARTURE</div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                ${this.dateFormated(this.departedDate)}</div>
            </div>
          </div>`;
          const popup = new mapboxgl.Popup({
            offset: 15,
            closeButton: false,
            closeOnClick: false,
          }).setHTML(popupContent);
          positionMarker.setPopup(popup);
          const markerDiv = positionMarker.getElement();
          markerDiv.addEventListener("mouseenter", () => {
            icon.src = hoverImageSrc;
            positionMarker.togglePopup();
          });
          markerDiv.addEventListener("mouseleave", () => {
            icon.src = defaultImageSrc;
            positionMarker.togglePopup();
          });
        }

        // 4- EN-route event (Destination Customs Released)
        if (this.shipPosition[i].eventName == "Departed") {
          const defaultImageSrc = require("../assets/ship.png");
          const hoverImageSrc = require("../assets/ship-red.png");
          const icon = document.createElement("img");
          icon.src = defaultImageSrc;
          icon.style.width = "20px";
          const positionMarker = new mapboxgl.Marker({
            color: "#000000",
            scale: 0.75,
            element: icon,
          })
          .setLngLat([this.shipPosition[i].lng, this.shipPosition[i].lat])
          .addTo(this.map);
          const majorTransportType = this.shipment.majorTransportType;
          const containers = this.shipment.containers;
          const incoterms = this.shipment.incoterms;
          const shipmentType = this.shipment.shipmentType;
          const popupContent = `

          <div class="card" style="padding: 5px;">
            <div>
              <div style="font-size:12px;font-weight:700">En-route</div>
            </div>
            <div style="margin-bottom:10px">
              Freight - ${majorTransportType} 
            </div>
            <div>
              <div style="display:flex">
                <div>
                  <img src="${require("../assets/container-mp.png")}" alt="Image Description1"/> 
                </div>
                <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">CONTAINER </div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                ${containers}</div>
            </div>
            <div>
              <div style="display:flex">
                <div>
                  <img src="${require("../assets/leave.png")}" alt="Image Description2" />
                </div>
                <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">INCOTERM</div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                ${incoterms}</div>
            </div>
            <div>
              <div style="display:flex">
                <div>
                  <img src="${require("../assets/bll.png")}" alt="Image Description3"  />
                </div>
                <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">LOAD</div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                ${shipmentType}</div>
            </div>
          </div>`;











          // <div class="card" style="padding:10px">
          //   <div> 
          //     <div style="font-size: 12px;font-weight: 700"> En-route </div>
          //   </div>
          //   <div style="margin-bottom:10px"> 
          //     <div style="font-size: 12px;font-weight: 400"> Freight - ${majorTransportType} </div>   
          //   </div> 
             
          //     <div style="display:flex">
          //       <div>
          //         <img src="${require("../assets/container-mp.png")}" alt="Image Description1"/> 
          //       </div>
          //       <div style="font-size:10px;font-weight:700;margin-left:3px"> CONTAINER <div>
          //     </div>
          //     <div style="font-size:10px;font-weight:700;margin-left:18px">${containers}</div>
       
            
          //     <div style="display:flex">
          //       <div>
          //         <img src="${require("../assets/leave.png")}" alt="Image Description2" />
          //       </div>
          //       <div style="font-size:10px;font-weight:700;margin-left:3px"> INCOTERM <div>  
          //     </div>
          //     <div style="font-size:10px;font-weight:700;margin-left:18px">${incoterms}</div>
           
    
          //     <div style="display:flex">
          //       <div>
          //         <img src="${require("../assets/bll.png")}" alt="Image Description3"  />
          //       </div>
          //       <div style="font-size:10px;font-weight:700;margin-left:3px"> LOAD <div>
          //     </div> 
          //     <div style="font-size:10px;font-weight:700;margin-left:18px">${shipmentType} </div>
          
          // </div>`;
          const popup = new mapboxgl.Popup({
            offset: 15,
            closeButton: false,
            closeOnClick: false,
          }).setHTML(popupContent);
          positionMarker.setPopup(popup);
          const markerDiv = positionMarker.getElement();
          markerDiv.addEventListener("mouseenter", () => {
            icon.src = hoverImageSrc;
            positionMarker.togglePopup();
          });
          markerDiv.addEventListener("mouseleave", () => {
            icon.src = defaultImageSrc;
            positionMarker.togglePopup();
          });
        }
        // 5- Destination Customs Released Event
        if (this.shipPosition[i].eventName == "Destination Customs Released") {
          const defaultImageSrcDes = require("../assets/containers-new.png");
          const hoverImageSrcDes = require("../assets/container-red.png");
          const icon = document.createElement("img");
          icon.src = defaultImageSrcDes;
          icon.style.width = "20px";
          const positionMarker = new mapboxgl.Marker({
            color: "#000000",
            scale: 0.75,
            element: icon,
          })
          .setLngLat([this.shipPosition[i].lng, this.shipPosition[i].lat])
          .addTo(this.map);
          const portOfDischargeName = this.shipment.portOfDischargeName;
          const popupContent = `
          <div class="card" style="padding: 5px;">
            <div>
              <div style="font-size:12px;font-weight:700">Port Name</div>
            </div>
            <div style="margin-bottom:10px">
              ${portOfDischargeName}
            </div>
            <div>
              <div style="display:flex">
                <div><img src="${require("../assets/calendar.png")}" alt="Image Description1"/></div>
                <div  style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">CUSTOMS CLEARANCE</div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                ${this.dateFormated(
                this.destinationCustomRealasedDate
              )}</div>
            </div>
            <div>
              <div style="display:flex">
                <div><img src="${require("../assets/calendar.png")}" alt="Image Description1"/></div>
                <div  style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">ESTIMATED ARRIVAL</div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">${this.dateFormated(
                this.arrivedDate
              )}</div>
            </div>
          </div>`;

          const popup = new mapboxgl.Popup({
            offset: 15,
            closeButton: false,
            closeOnClick: false,
          }).setHTML(popupContent);

          positionMarker.setPopup(popup);

          const markerDiv = positionMarker.getElement();

          markerDiv.addEventListener("mouseenter", () => {
            icon.src = hoverImageSrcDes;
            positionMarker.togglePopup();
          });

          markerDiv.addEventListener("mouseleave", () => {
            icon.src = defaultImageSrcDes;
            positionMarker.togglePopup();
          });
        }

        // 6- Available for Drop-off Event
        if (this.shipPosition[i].eventName == "Available for Drop-off") {
          icon.src = require("../assets/truck.png");
          icon.style.width = "20px";
          const positionMarker = new mapboxgl.Marker({
            color: "#000000",
            scale: 0.75,
            element: icon,
          })
            .setLngLat([this.shipPosition[i].lng, this.shipPosition[i].lat])
            .addTo(this.map);
          const transportTypes = this.showTypeOfTransport;

          const popupContent = `
            <div class="card" style="padding:5px">
              <div> 
                <div style="font-size:12px;font-weight:700"> Transport </div>
              </div>
              <div style="margin-bottom:10px"> 
                ${transportTypes} 
              </div>
              <div>
                <div style="display:flex">
                  <div><img src="${require("../assets/calendar.png")}" alt="Image Description1"/> </div>  
                  <div style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px"> CARGO READY FOR DELIVERY  </div>
                </div>
                <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                  ${this.dateFormated(this.availableForDropOffDate)}
                </div>
              </div>
           
            </div>`;
          const popup = new mapboxgl.Popup({
            offset: 15,
            closeButton: false,
            closeOnClick: false,
          }).setHTML(popupContent);
          positionMarker.setPopup(popup);
          const markerDiv = positionMarker.getElement();
          markerDiv.addEventListener("mouseenter", () =>
            positionMarker.togglePopup()
          );
          markerDiv.addEventListener("mouseleave", () =>
            positionMarker.togglePopup()
          );
        }
        // 7- Arrived
        if (this.shipPosition[i].eventName == "Arrived") {
          const defaultImageSrcDes = require("../assets/containers-new.png");
          const hoverImageSrcDes = require("../assets/container-red.png");
          const icon = document.createElement("img");
          icon.src = defaultImageSrcDes;
          icon.style.width = "20px";
          const positionMarker = new mapboxgl.Marker({
            color: "#000000",
            scale: 0.75,
            element: icon,
          })
          .setLngLat([this.shipPosition[i].lng, this.shipPosition[i].lat])
          .addTo(this.map);
          const portOfDischargeName = this.shipment.portOfDischargeName;
          const popupContent = `
          <div class="card" style="padding: 5px;">
            <div>
              <div style="font-size:12px;font-weight:700">Port Name</div>
            </div>
            <div style="margin-bottom:10px">
              ${portOfDischargeName}
            </div>
            <div>
              <div style="display:flex">
                <div><img src="${require("../assets/calendar.png")}" alt="Image Description1"/></div>
                <div  style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">CUSTOMS CLEARANCE</div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">
                ${this.dateFormated(
                  this.shipPosition[i].eventDateTime
              )}</div>
            </div>
            <div>
              <div style="display:flex">
                <div><img src="${require("../assets/calendar.png")}" alt="Image Description1"/></div>
                <div  style="font-size:8px;font-weight:700;margin-left:10px;margin-top:-4px">ESTIMATED ARRIVAL</div>
              </div>
              <div style="font-size:8px;font-weight:600;margin-left:27px;margin-top:-15px">${this.dateFormated(
                this.arrivedDate
              )}</div>
            </div>
          </div>`;

          const popup = new mapboxgl.Popup({
            offset: 15,
            closeButton: false,
            closeOnClick: false,
          }).setHTML(popupContent);

          positionMarker.setPopup(popup);

          const markerDiv = positionMarker.getElement();

          markerDiv.addEventListener("mouseenter", () => {
            icon.src = hoverImageSrcDes;
            positionMarker.togglePopup();
          });

          markerDiv.addEventListener("mouseleave", () => {
            icon.src = defaultImageSrcDes;
            positionMarker.togglePopup();
          });
        }

      }}
      // position Marker events based code end here

      this.addZoomFunctionality();
    },
    displayPortName(cords, count) {
      let mk = new mapboxgl.Popup({ closeOnClick: false, closeButton: false })
        .setLngLat([cords.lng, cords.lat])
        .setHTML(
          `<div style='heigth:fit-content; width:fit-content; font-size: 12px'>${`<strong>${cords.title}</strong>`}</div>`
        )
        .addTo(this.map);
    },

    addZoomFunctionality() {
      let mapData = {
        type: "FeatureCollection",
        features: [],
      };
      for (let marker of this.markers) {
        let featureData = {
          type: "Feature",
          properties: {
            title: null,
          },
          geometry: {
            type: "Point",
            coordinates: [marker.lng, marker.lat],
          },
        };

        mapData.features.push(featureData);
      }
      this.map.on("load", () => {
        // Add a GeoJSON source with 3 points.
        this.map.addSource("points", {
          type: "geojson",
          data: mapData,
        });
        // Add a circle layer
        this.map.addLayer({
          id: "circle",
          type: "circle",
          source: "points",
          paint: {
            "circle-color": "#4264fb",
            "circle-radius": 8,
            "circle-stroke-width": 5,
            "circle-stroke-color": "#ffffff",
          },
        });

        // Center the map on the coordinates of any clicked circle from the 'circle' layer.
        this.map.on("click", "circle", (e) => {
          this.map.flyTo({
            center: e.features[0].geometry.coordinates,
            zoom: 10,
          });
          this.showTitlePopUp(e.features[0]);
        });
      });
    },

    showTitlePopUp(e) {
      if (e.properties.title) {
        new mapboxgl.Popup({})
          .setLngLat([e.geometry.coordinates[0], e.geometry.coordinates[1]])
          .setHTML(
            `<div style='heigth:fit-content; width:fit-content; font-size: 12px; padding: 5px 10px'>${`<strong>${e.properties.title}</strong>`}</div>`
          )
          .addTo(this.map);
      }
    },

    dynamicallyFitMapBounds() {
      var bounds = new mapboxgl.LngLatBounds();

      this.markers.forEach(function(feature) {
        bounds.extend([feature.lng, feature.lat]);
      });

      if (this.animation) {
        this.map.fitBounds(bounds, { padding: 50 });
      } else {
        if (!this.clusters) {
          if (this.markers.length == 1) {
            this.map.fitBounds(bounds, {
              padding: 50,
              duration: 0,
              maxZoom: this.zoom ? this.zoom : 10,
            });
          } else if (this.markers.length >= 1) {
            this.map.fitBounds(bounds, {
              padding: 50,
              duration: 0,
              zoom: this.zoom,
            });
          }
        }

        if (this.clusters) {
          if (this.markers.length == 1) {
            this.map.fitBounds(bounds, {
              padding: 50,
              duration: 0,
              maxZoom: 10,
            });
          } else if (this.markers.length >= 1) {
            this.map.fitBounds(bounds, {
              padding: 50,
              duration: 0,
              zoom: this.zoom,
            });
          }
        }
      }
    },

    drawClusters() {
      mapboxgl.accessToken = this.accessToken;

      this.map = new mapboxgl.Map({
        container: this.id,
        style: "mapbox://styles/mapbox/light-v10",
        center: [53.8784, 23.2421],
        zoom: 6,
      });

      this.map.on("load", () => {
        // Add a new source from our GeoJSON data and
        // set the 'cluster' option to true. GL-JS will
        // add the point_count property to your source data.
        // this.map.addSource();

        this.map.addSource("earthquakes", {
          type: "geojson",
          // Point to GeoJSON data. This example visualizes all M1.0+ earthquakes
          // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
          data:
            "https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson",
          cluster: true,
          clusterMaxZoom: 10, // Max zoom to cluster points on
          clusterRadius: 80, // Radius of each cluster when clustering points (defaults to 50)
        });

        this.map.addLayer({
          id: "clusters",
          type: "circle",
          source: "earthquakes",
          filter: ["has", "point_count"],
          paint: {
            // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
            // with three steps to implement three types of circles:
            //   * Blue, 20px circles when point count is less than 100
            //   * Yellow, 30px circles when point count is between 100 and 750
            //   * Pink, 40px circles when point count is greater than or equal to 750
            "circle-color": [
              "step",
              ["get", "point_count"],
              "#51bbd6",
              100,
              "#f1f075",
              750,
              "#f28cb1",
            ],
            "circle-radius": [
              "step",
              ["get", "point_count"],
              20,
              100,
              30,
              750,
              40,
            ],
          },
        });

        this.map.addLayer({
          id: "cluster-count",
          type: "symbol",
          source: "earthquakes",
          filter: ["has", "point_count"],
          layout: {
            "text-field": "{point_count_abbreviated}",
            "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
            "text-size": 12,
          },
        });

        this.map.addLayer({
          id: "unclustered-point",
          type: "circle",
          source: "earthquakes",
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": "#11b4da",
            "circle-radius": 4,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff",
          },
        });

        // inspect a cluster on click
        this.map.on("click", "clusters", function(e) {
          var features = map.queryRenderedFeatures(e.point, {
            layers: ["clusters"],
          });
          var clusterId = features[0].properties.cluster_id;
          this.map
            .getSource("earthquakes")
            .getClusterExpansionZoom(clusterId, function(err, zoom) {
              if (err) return;

              map.easeTo({
                center: features[0].geometry.coordinates,
                zoom: zoom,
              });
            });
        });

        // When a click event occurs on a feature in
        // the unclustered-point layer, open a popup at
        // the location of the feature, with
        // description HTML from its properties.
        this.map.on("click", "unclustered-point", function(e) {
          var coordinates = e.features[0].geometry.coordinates.slice();
          var mag = e.features[0].properties.mag;
          var tsunami;

          if (e.features[0].properties.tsunami === 1) {
            tsunami = "yes";
          } else {
            tsunami = "no";
          }

          // Ensure that if the map is zoomed out such that
          // multiple copies of the feature are visible, the
          // popup appears over the copy being pointed to.
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }

          new mapboxgl.Popup()
            .setLngLat(coordinates)
            .setHTML(
              "magnitude: " + mag + "<br>Was there a tsunami?: " + tsunami
            )
            .addTo(map);
        });

        this.map.on("mouseenter", "clusters", function() {
          this.map.getCanvas().style.cursor = "pointer";
        });
        this.map.on("mouseleave", "clusters", function() {
          this.map.getCanvas().style.cursor = "";
        });
      });
    },

    customClusters() {
      if (this.clusters === true) {
        let clusterData = {
          type: "FeatureCollection",
        };

        let clusterDataFeatures = [];
        for (let i = 0; i < this.markers.length; i++) {
          clusterDataFeatures.push({
            type: "Feature",
            properties: {
              id: i,
              type: this.markers[i].type,
              //   popup: this.mapMarkers[i].popupComponent,
            },
            geometry: {
              type: "Point",
              //   coordinates: this.mapMarkers[i].coordinates,
              coordinates: [this.markers[i].lng, this.markers[i].lat, 0],
            },
          });
        }
        clusterData.features = clusterDataFeatures;
        this.map.on("load", () => {
          this.map.addSource("clusters", {
            type: "geojson",
            data: clusterData,
            cluster: true,
            clusterMaxZoom: 10, // Max zoom to cluster points on
            clusterRadius: 80,
          });

          //CREATING A LAYER FOR CLUSTERING LOCATIONS
          this.map.addLayer({
            id: "clusters",
            type: "circle",
            source: "clusters",
            filter: ["has", "point_count"],
            paint: {
              // "circle-color": "#f00",
              // "circle-radius": 20,
              "circle-color": [
                "step",
                ["get", "point_count"],
                "#000",
                100,
                "#000",
                250,
                "#000",
                500,
                "#000",
              ],
              "circle-radius": [
                "step",
                ["get", "point_count"],
                20,
                80,
                30,
                550,
                40,
              ],
              "circle-stroke-width": 3,
              "circle-stroke-color": "#000",
              // "circle-stroke-color": "#f0efeb",
            },
          });

          //CREATING A LAYER FOR CLUSTER COUNT
          this.map.addLayer({
            id: "cluster-count",
            type: "symbol",
            source: "clusters",
            filter: ["has", "point_count"],
            layout: {
              "text-field": "{point_count_abbreviated}",
              "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
              "text-size": 18,
              "text-allow-overlap": false,
            },
            paint: {
              "text-color": "#e6e8e8", //greyish
            },
          });

          // LOADING ICON FOR THE UN-CLUSTERED POINTS
          this.map.loadImage(
            require("../assets/map icons/location.png"),
            (error, image) => {
              if (error) throw error;
              this.map.addImage("location", image); //ADDING THE ICONS WITH THE SAME NAME AS TYPE IN MARKERS ARRAY.
            }
          );

          this.map.loadImage(
            require("../assets/map icons/portIcon.png"),
            (error, image) => {
              if (error) throw error;
              this.map.addImage("port", image);
            }
          );

          this.map.loadImage(
            require("../assets/map icons/tnotification.png"),
            (error, image) => {
              if (error) throw error;
              this.map.addImage("notification", image);
            }
          );

          // CREATING A LAYER FOR SHOWING NON-CLUSTERED POINTS ON THE MAP.
          this.map.addLayer({
            id: "unclustered-point",
            type: "symbol",
            source: "clusters",
            filter: ["!", ["has", "point_count"]],
            layout: {
              "icon-image": ["get", "type"],
              "icon-size": 1,
            },
          });
        });
      }
    },

    drawLine() {
      let lineData = {
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",
          coordinates: [],
        },
      };
      let eventlineData = {
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",
          coordinates: [],
        },
      };

      for (let i = 0; i < this.markers.length; i++) {
        lineData.geometry.coordinates.push([
          this.markers[i].lng,
          this.markers[i].lat,
        ]);
      }
      
      let lineDataForEvent = {
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",          
          coordinates: [[0, 0], [-1, -1]],
        },
      };

      if(this.markers.length > 0)
      lineDataForEvent = {
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",          
          coordinates: [
            [this.markers[1].lng, this.markers[1].lat],
            [this.markers[0].lng, this.markers[0].lat],
          ],
        },
      };

      this.shipPosition.forEach((coordinate, i) => {
        if(coordinate != undefined)
          lineDataForEvent.geometry.coordinates.splice(i + 1, 0, [
            coordinate.lng,
            coordinate.lat,
          ]);
        });
      if (this.posLat == 0) {
        this.map.on("load", () => {
          //Adding source for route
          this.map.addSource("route", {
            type: "geojson",
            data: lineData,
          });

          //Layer for line
          this.map.addLayer({
            id: "route",
            type: "line",
            source: "route",
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#979797",
              "line-width": 1,
              "line-dasharray": [10, 3],
            },
          });
        });
      } else {
        this.map.on("load", () => {
          this.map.addControl(
            new mapboxgl.NavigationControl({
              position: "bottom-left",
            })
          );
          this.map.addSource("route", {
            type: "geojson",
            data: lineDataForEvent,
          });

          this.map.addLayer({
            id: "route",
            type: "line",
            source: "route",
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#979797",
              "line-width": 1,
              "line-dasharray": [10, 3],
            },
          });
        });
      }
    },

    // THIS FUNCTION IS PRETTY MUCH SAME AS IN THE API'S DOCUMNETATION IT TAKES AS INPUT LOACTION TO BE SEARCHED IN JSON FORMAT CREATES A UTF-8 FORMAT URL THEN RETURNS THE SUGGESTIONS IF ANY.
    // THE RETURN PART IS NOT NEEDED CAUSE WE WILL RELYING ON WATCHERS TO NAVIGATE DATA.
    async getLocations(searchInput, drag = false) {
      let url = "";
      if (typeof searchInput == "object") {
        if (isNaN(searchInput.longitude) || isNaN(searchInput.latitude)) {
          return;
        }
        let temp = searchInput.longitude + "," + searchInput.latitude;
        url =
          "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
          temp +
          ".json?access_token=" +
          this.accessToken; // YOUR ACCESS TOKEN FOR THE MAP.
      } else {
        url =
          "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
          searchInput +
          ".json?access_token=" +
          this.accessToken; // YOUR ACCESS TOKEN FOR THE MAP.
      }
      try {
        return await axios
          .get(url)
          .then((responseJson) => {
            this.searchOpts = [];
            this.searchOpts = responseJson.data.features; // UPDATING THE SUGGESTIONS ARRAY WITH THE LOCATIONS FROM RESPONSE.
            if (drag) {
              this.$emit("selected-location", this.searchOpts[0]); //EMITTING THE SELECTED LOCATION DATA
            }
          })
          .catch((error) => {
            console.log("Map.getLocations_innder", error);
          });
      } catch (e) {
        console.log("Map.getLocations_outer", e);
      }
    },

    addSourceToMap() {
      let sourceData = {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      };

      // ADDING AN EMPTY SOURCE TO THE MAP SO THAT I CAN UPDATE IT WHENEVER THERE IS A CHANGE. ALTERNATIVE WOULD BE TO ADD and REMOVE A SOUCER FROM MAP WHEN THERE IS A CHNAGE. THAT IS UNNECESSARY.
      this.map.on("load", () => {
        this.map.addSource("searchSource", sourceData);

        // Add a symbol layer
        this.map.addLayer({
          id: "points",
          type: "circle",
          source: "searchSource",
          paint: {
            "circle-color": "#11b4da",
            "circle-radius": 4,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff",
          },
          // layout: {
          //   "icon-image": "custom-marker",
          //   // get the title name from the source's "title" property
          //   "text-field": ["get", "title"],
          //   "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
          //   "text-offset": [0, 1.25],
          //   "text-anchor": "top",
          // },
        });
      });
    },

    updateSource() {
      let temp = {
        //ALTHOUGH ALL OF THIS OBJECT (HEIRARCHY) IS NOT NEEDED BUT I HAVE KEPT IT AS SUCH BECAUSE IT WAS HOW I ORIGNALLY CREATED IT AND ALSO IT MAKES IT EASIER TO UNDERSTAND WHAT IS ACUTALLY GOING ON.
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [this.source],
        },
      };

      this.map.getSource("searchSource").setData(temp.data); //HERE THE SOURCE IS BEING UPDATED BY THE NEWLY SELECTED LOCATION.
      this.map.setCenter(this.source.center); // SETTING MAPS CENTER TO THE NEW LOCATION SO THAT ZOOMING BECOMES BETTER.

      // let temp = this.source.place_type[0];
      let zoom = 0; //GOING TO MAKE THE ZOOM VALUE CORRESPOND TO THE TYPE OF LOCATION.
      if (
        this.source.place_type[0] === "country" ||
        this.source.place_type[0] === "reigon"
      ) {
        zoom = 6;
      } else if (
        this.source.place_type[0] === "postcode" ||
        this.source.place_type[0] === "district"
      ) {
        zoom = 8;
      } else if (
        this.source.place_type[0] === "place" ||
        this.source.place_type[0] === "locality" ||
        this.source.place_type[0] === "neighborhood"
      ) {
        zoom = 10;
      } else if (
        this.source.place_type[0] === "address" ||
        this.source.place_type[0] === "poi"
      ) {
        zoom = 13;
      }

      // this.map.panTo(this.source.geometry.coordinates,{duration: 2000});

      // ESSENTIALLY FLYING TO THE NEWLY SELECTED LOCATION.
      this.map.flyTo({
        center: this.source.geometry.coordinates,
        zoom: zoom,
        speed: 2,
        curve: 1,
        easing(t) {
          return t;
        },
      });

      if (this.searchMarker !== null) {
        this.searchMarker.remove(); //IF THERE EXISTS A MARKER ON THE MAP REMOVING IT SO THAT THERE MAY NOT BE ANY CONSUSION.
      }
      // CREATING A MARKER AT THE NEW LOCATION'S COORDIANTES
      this.searchMarker = new mapboxgl.Marker({
        color: "#000000",
        draggable: true,
      })
        .setLngLat(this.source.geometry.coordinates)
        .addTo(this.map);
      let tempRef = this;

      let tempCoors = {
        latitude: NaN,
        longitude: NaN,
        drag: false,
      };

      function dragMarker(e) {
        (tempCoors.latitude = e.target.getLngLat().lat),
          (tempCoors.longitude = e.target.getLngLat().lng),
          (tempCoors.drag = true);

        tempRef.getLocations(tempCoors, true);
        // tempRef.dragFunc();
      }

      this.searchMarker.on("dragend", dragMarker);
      // console.log(tempCoors.drag);
      this.$emit("selected-location", this.source); //EMITTING THE SELECTED LOCATION DATA
    },
    dragFunc() {
      this.$emit("selected-location", this.searchOpts[0]); //EMITTING THE SELECTED LOCATION DATA
    },
  },

  watch: {
    source: {
      deep: true,
      handler() {
        // console.log("watch");
        // CALLLING THE UPDATE FUNCTION THAT WILL DRAW THE SELECTED LOCATION ON MAP.
        this.updateSource();
      },
    },

    searchtText: {
      // deep: true, ALTHOUGH IT IS NOT REQUIRED JUST FORCE OF HABBIT :'-)
      handler(nv, ov) {
        // FOLLWING CHECK IS FOR WHEN THE SEARCH TEXT IS EMPTY/NULL THEN NO CALL SHOULD BE MADE.
        if (this.searchtText !== "" || this.searchtText !== null) {
          // PARSING THE SEARCH AS JSON BEACUSE THAT IS THE API'S REQUIREMENT.
          this.getLocations(JSON.stringify(this.searchtText));
        }
      },
    },

    searchOpts: {
      deep: true,
      handler() {
        // EMITTING WITH EMPTY ARRAY BCZ THE SUGGESTION CONTAIN THE DATA FOR LAST SEARCH IN ORDER TO EMPTY THAT THIS IS WHAT'S BEEN DONE.
        if (this.searchOpts.length === 0) {
          this.$emit("search-suggestions", []);
        }
        // IF SUGGESTIONS/SEARCHOPTS HAVE VALUES IN THE THEN THE FOLLOWING EMIT IS EXECUTED.
        else if (this.searchOpts.length > 0) {
          this.$emit("search-suggestions", this.searchOpts);
        }
      },
    },

    searchCoors: {
      deep: true,
      handler(nv, ov) {
        // console.log(this.searchCoors)
        // FOLLWING CHECK IS FOR WHEN THE SEARCH COORS IS EMPTY/NULL THEN NO CALL SHOULD BE MADE.
        if (
          this.searchCoors.latitude !== null &&
          this.searchCoors.longitude !== null
        ) {
          this.getLocations(this.searchCoors);
        }
      },
    },
  },
};
</script>

<style scoped>
@import "https://api.mapbox.com/mapbox-gl-js/v1.10.1/mapbox-gl.css";
.marker-icon {
  width: 100px;
  height: 100px;
}
</style>
